import { LoyaltyIcon } from '@/components/features/BottomNav/icons/LoyaltyIcon';

/**
 * `/loyalty` route.
 *
 * Placeholder mock page for the upcoming loyalty / rewards experience.
 * Renders a simple centered empty state until the real feature is built.
 *
 * The top bar and bottom nav are owned by the app shell singletons.
 */
export function LoyaltyPage() {
  return (
    <div className="flex flex-1 flex-col pb-[calc(82px+env(safe-area-inset-bottom))] md:pb-0">
      <div className="flex flex-1 flex-col items-center justify-center gap-3 px-4 text-center">
        <span className="flex items-center justify-center size-16 rounded-full bg-accent/10 text-accent">
          <LoyaltyIcon className="size-8" />
        </span>
        <h1 className="text-xl font-semibold text-primary">Loyalty</h1>
        <p className="max-w-xs text-sm text-muted">Rewards and loyalty perks are on their way.</p>
      </div>
    </div>
  );
}
